
<div *ngIf="booksInFav$ | async as booksInFav" app-theme class="app-theme" style="min-height: 100vh;">
    <div class="flex-row justify-between">
        <div *ngFor="let book of booksInFav" class="inline-block m-5">
            <div class="rounded w-60 h-auto">
                <figure>
                    <img src="{{book.volumeInfo.imageLinks?.thumbnail}}" class="w-auto h-auto m-3" alt="">
                    <figcaption>
                        <div class="overflow-hidden overflow-ellipsis">{{book.volumeInfo.title}}</div>
                        <div class="text-gray-600">{{book.volumeInfo.authors}}</div>
                        <div class="flex flex-col">
                            <div class="flex flex-row">
                                <div class="flex mt-2 mb-4 align-items-center"> 
                                    <span *ngFor="let star of numSequence(book.volumeInfo.averageRating, 'rating')"><svg class="mx-1 w-3 h-3 fill-current text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg></span>
                                    <span *ngFor="let star of numSequence(book.volumeInfo.averageRating, 'nonRating')"><svg class="mx-1 w-3 h-3 fill-current text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg></span>
                                </div>
                                <div class="ml-2" style="font-size: 14px;" *ngIf="book.volumeInfo.ratingsCount > 0">({{book.volumeInfo.ratingsCount}})</div>
                            </div>
                            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" (click)="deleteFromFav(book)">
                                Delete
                              </button>
                        </div>
                    </figcaption>
                </figure>
            </div>
        </div>
    </div>
</div>